export default __webpack_public_path__ + "static/media/logo.b592f610.svg";